import React from 'react'
import {ShowGuesser} from '@api-platform/admin'
import {TextField, NumberField, SingleFieldList, ChipField, ReferenceArrayField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="kpiNumber" label={t('admin.kpiNumber')}/>
            <NumberField source="foreignId" label={'foreignId'}/>
            <ReferenceArrayField label={t('admin.efficiencyMetrics')} source="efficiencyMetrics"
                                 reference="dictionary/efficiency_metrics" link={true} >
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>
            </ReferenceArrayField>
        </ShowGuesser>
    )
}

export default Show
